<div class="hmn-unit-details-calendar__grid hmn-grid__gap-s hmn-height__full">
  <app-unit-details-calendar-cell
    *ngFor="let cell of cells; let i = index"
    [day]="cell"
    [day_number]="getDayOfMonthNumber(cell)"
    [day_label]="getDayOfWeekLabel(cell)"
    [bookings]="bookings">
  </app-unit-details-calendar-cell>
</div>
